import {
    LogicStepParameter,
    LogicStepParameterProperty,
    LogicStepParameterType,
} from '@wdx/shared/utils';
import {
    ActiveFieldState,
    BaseSegmentedControlStrategy,
} from './base-segmented-control-strategy.service';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class RelativeDateStrategy extends BaseSegmentedControlStrategy {
    private inputParam?: LogicStepParameterProperty;
    private unitParam?: LogicStepParameterProperty;
    private keywordsParam?: LogicStepParameterProperty;

    override init(parameter: LogicStepParameter, formGroup: FormGroup): void {
        this.inputParam = parameter.properties?.find((p) => p.code === 'Input');
        this.unitParam = parameter.properties?.find((p) => p.code === 'Unit');
        this.keywordsParam = parameter.properties?.find(
            (p) => p.code === 'Keywords',
        );
        super.init(parameter, formGroup);
    }

    protected resolveKind(kind: string | null): ActiveFieldState {
        switch (kind) {
            case 'Keyword':
                return { Keywords: this.keywordsParam };
            case 'Offset':
                return {
                    Input: {
                        ...this.inputParam,
                        kind: LogicStepParameterType.Integer,
                    },
                    Unit: this.unitParam,
                };
            case 'SpecificDate':
                return {
                    Input: {
                        ...this.inputParam,
                        kind: LogicStepParameterType.Date,
                    },
                };
            default:
                return {};
        }
    }
}
